import React from 'react';

interface SectionHeaderBarActionsProps {
    children: React.ReactNode;
}

export const SectionHeaderBarActions: React.FC<SectionHeaderBarActionsProps> = ({ children }) => {
    return <div style={{ display: 'flex', gap: 20, width: '100%' }}>{children}</div>;
};
